import React from 'react';
import { Spinner } from 'react-bootstrap';
import { cssVar } from 'constants/theme';

export default function HeatmapDisplay({
  base64,
  fetching,
  imageMaxWidth = '70%',
}: {
  base64: string;
  fetching: boolean;
  imageMaxWidth?: string;
}) {
  if (fetching) {
    return <div className="text-center mt-5"><Spinner /></div>;
  }
  if (!base64) {
    return (
      <div className="images-not-found">
        Não foi encontrada imagem para a combinação selecionada
      </div>
    );
  }
  return (
    <div className="d-flex justify-content-center my-3 bg-white">
      <img
        src={`data:image/png;base64,${base64}`}
        alt="Heatmap"
        style={{ maxWidth: imageMaxWidth, height: 'auto', backgroundColor: cssVar('bg-figure') }}
      />
    </div>
  );
}
